module.exports = __webpack_public_path__ + "img/game-zc.e5c003ee.png";